module.exports = __webpack_public_path__ + "static/media/b1_p15_melody.8dd19ac7.mp3";